var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSepratorArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 649,
    height: 23,
    viewBox: "0 0 649 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7724 14.822C27.6562 14.822 29.1834 13.2948 29.1834 11.411C29.1834 9.52715 27.6562 8 25.7724 8C23.8886 8 22.3613 9.52715 22.3613 11.411C22.3613 13.2948 23.8886 14.822 25.7724 14.822Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3699C0 11.3699 13.644 14.7809 20.087 22.7399C20.087 22.7399 18.192 14.0229 18.192 11.3699C18.192 8.71695 20.087 0 20.087 0C13.644 7.95895 0 11.3699 0 11.3699Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M621 10.9999L28 11",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M623.228 14.822C625.112 14.822 626.639 13.2948 626.639 11.411C626.639 9.52715 625.112 8 623.228 8C621.344 8 619.817 9.52715 619.817 11.411C619.817 13.2948 621.344 14.822 623.228 14.822Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M649 11.3699C649 11.3699 635.356 7.95895 628.913 0C628.913 0 630.808 8.71695 630.808 11.3699C630.808 14.0229 628.913 22.7399 628.913 22.7399C635.356 14.7809 649 11.3699 649 11.3699Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSepratorArrow);
export default __webpack_public_path__ + "static/media/sepratorArrow.3ae3bd14abe710f86720ae212622b093.svg";
export { ForwardRef as ReactComponent };